import { render, staticRenderFns } from "./dragging.vue?vue&type=template&id=8ca4cfe2&"
import script from "./dragging.vue?vue&type=script&lang=js&"
export * from "./dragging.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports